<template>
  <PageWrapper
    :active-section="SECTION_SETTINGS"
    :active-page="PAGE_MY_SERVICES"
    title="My Expert Services"
    :breadcrumbs="breadcrumbs"
    page-name="My Expert Services"
    align="center"
    width="full"
  >
    <iColumn gap="extraLarge">
      <iColumn gap="standard">
        <iSubHeading font-size="extraLarge">
          Areas of expertise
        </iSubHeading>
        <iColumn gap="small" width="fill">
          <iCheckbox
            v-for="area in expertiseAreas"
            :key="area.id"
            v-model="area.selected"
            :label="area.label"
            :is-loading="isLoadingToggleExpertiseArea(area.id)"
            @change="updateExpertiseArea(area.id)"
          />
        </iColumn>
      </iColumn>

      <iColumn gap="standard">
        <iRow align="between" width="fill">
          <iSubHeading font-size="extraLarge">
            My Packages
          </iSubHeading>
          <iButton size="small" @click="createServicePackage">
            Create Service Package
          </iButton>
        </iRow>

        <SmartFeed
          :source="useMyExpertServicePackageFeedStore"
          default-feed-layout="table"
        >
          <template #empty-state>
            <iSpace :height="50" />
            <iColumn gap="large" align="center">
              <iColumn gap="standard" align="center">
                <iSubHeading variant="subtle" font-size="large">
                  No Service Packages Yet
                </iSubHeading>
                <iParagraph
                  variant="subtle"
                  text-align="center"
                  :max-width="400"
                >
                  When you create service packages, they'll appear here for easy
                  access and management
                </iParagraph>
              </iColumn>
            </iColumn>
          </template>
        </SmartFeed>
      </iColumn>
    </iColumn>

    <ExpertServicePackageModal />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { PAGE_MY_SERVICES, SECTION_SETTINGS } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useMyExpertServicePackageFeedStore } from "@/smart-feed/stores/feed/my-expert-service-package-feed-store";
import { mapState, mapActions } from "pinia";
import { useExpertServicePackageStore } from "@/stores/expert-service-package-store";
import { useGeneralStore } from "%/stores/general-store";
import ExpertServicePackageModal from "@/components/expert-service-packages/ExpertServicePackageModal.vue";
import { EXPERTISE_AREAS } from "@/constants/expert-constants";

export default {
  name: "MyServices",
  components: {
    ExpertServicePackageModal: ExpertServicePackageModal,
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_SETTINGS,
      PAGE_MY_SERVICES,
      expertiseAreas: EXPERTISE_AREAS.map(area => ({
        ...area,
        selected: false,
      })),
    };
  },
  computed: {
    ...mapState(useExpertServicePackageStore, [
      "expertPackageModalOpen",
      "activeExpertIds",
      "isLoadingAddExpert",
      "isLoadingRemoveExpert",
      "currentExpertiseId",
    ]),
    ...mapState(useGeneralStore, ["orgId"]),
    breadcrumbs() {
      return [{ url: "/", label: "Home" }, { label: "My Services" }];
    },
  },
  mounted() {
    this.initializeExpertiseAreas();
  },
  methods: {
    useMyExpertServicePackageFeedStore,
    ...mapActions(useExpertServicePackageStore, [
      "openExpertPackageModal",
      "addOrgExpertise",
      "removeOrgExpertise",
    ]),

    isLoadingToggleExpertiseArea(expertiseId) {
      const isCurrentExpertiseId = expertiseId === this.currentExpertiseId;
      return (
        isCurrentExpertiseId &&
        (this.isLoadingAddExpert || this.isLoadingRemoveExpert)
      );
    },

    createServicePackage() {
      this.openExpertPackageModal("create");
    },

    initializeExpertiseAreas() {
      this.expertiseAreas.forEach(area => {
        area.selected = this.activeExpertIds.includes(area.id);
      });
    },

    updateExpertiseArea(expertId) {
      const area = this.expertiseAreas.find(area => area.id === expertId);
      if (area.selected) {
        this.addOrgExpertise(this.orgId, expertId);
      } else {
        this.removeOrgExpertise(this.orgId, expertId);
      }
    },
  },
};
</script>
